import { io } from "socket.io-client"
import { createContext } from "react"

const baseURL = window.origin.includes("localhost") ? "http://localhost:8080" : window.origin

export const defaultSocketService = io.connect(baseURL, {withCredentials: true, autoConnect: false})
export const notificationsSocketService = io.connect(`${baseURL}/notification`, {withCredentials: true, autoConnect: false})
export const articlesSocketService = io.connect(`${baseURL}/articles`, {withCredentials: true, autoConnect: false})
export const notesSocketService = io.connect(`${baseURL}/notes`, {withCredentials: true, autoConnect: false})
export const noteRestrictionsService = io.connect(`${baseURL}/noteRestrictions`, {withCredentials: true, autoConnect: false})
export const noteAttachmentService = io.connect(`${baseURL}/noteAttachments`, {withCredentials: true, autoConnect: false})

const services = [
	defaultSocketService,
	notificationsSocketService,
	articlesSocketService,
	notesSocketService,
	noteRestrictionsService,
	noteAttachmentService,
]

export const connectAllSocketServices = (getToken) => {
	// should get `getAccessTokenSilently`, but possible to de-couple from auth0
	const authFn = (cb) => {
		getToken()
			.then(token => cb({ token }))
			.catch(() => cb({}))
	}

	services.forEach(wsService => {
		wsService.auth = authFn
		wsService.connect()
	})
}

export const disconnectAllSocketServices = () => {
	services.forEach(s => s.disconnect())
}

export const SocketContext = createContext(defaultSocketService)
